import { useState, useEffect, useRef } from "react";
import { Upload, Eye, Printer, X, Search, CheckCircle, FileText, Clock, ChevronDown } from "lucide-react";
import vietnamLogo from "../assets/vietnam-logo.png";

const VNA_BRANCHES = {
  "07AADCV5961H2Z1": { a1:"301-302 SALCON RAVILLAS - ROAD D1", a2:"SAKET - SOUTH DELHI",             a3:"DELHI-110017",             state:"07" },
  "27AADCV5961H1Z0": { a1:"LEVEL3-W8/3060 CHHATRAPATI SHIVAJI INTL AIRPORT", a2:"CSMIA MUMBAI",      a3:"MAHARASHTRA-400099",        state:"27" },
  "29AADCV5961H1ZW": { a1:"UNIT 001-002 PARVATI PLAZA, RICHMOND RD,",        a2:"BANGALORE",          a3:"KARNATAKA-560025",          state:"29" },
  "36AADCV5961H1Z1": { a1:"3-5-1049 NARAYANGUDA X ROAD SECUNDERABAD",        a2:"HYDERABAD",          a3:"TELANGANA-500029",          state:"36" },
};

const SEED = [
  { id:"1", invoiceNo:"VN/JD2526/0214267", invoiceDate:"27-Feb-26", customerName:"HYUNDAI MOTOR INDIA LIMITED",       customerGSTIN:"27AAACH2364M1ZF", customerAddress:"Maharashtra",                                        passengerName:"LEE/HYUNWOOK MR",          serviceDate:"27-Feb-26", ticketNumber:"7385014295678", classBooking:"Economy",  travelDetail:"BOM\\SGN\\ICN\\HAN\\BOM",  baseCharge:104931, otherCharge:9094,  totalCollection:114025, taxRate:5,  cgst:2623.5, sgst:2623.5, igst:0,     gstApplied:5247,  supplierGSTIN:"07AADCV5961H2Z1", placeOfService:"07-Delhi",       status:"Invoice Received", type:"International" },
  { id:"2", invoiceNo:"VN/JD2526/0300001", invoiceDate:"03-Mar-26", customerName:"B2C",                                customerGSTIN:"B2C",             customerAddress:"09-Uttar Pradesh",                                  passengerName:"SHROFF/NILOUFER NOSHIR MS",serviceDate:"03-Mar-26", ticketNumber:"7385014277208", classBooking:"Business", travelDetail:"DEL\\SGN\\DAD\\HAN\\DEL",  baseCharge:2755,   otherCharge:508,   totalCollection:3263,   taxRate:18, cgst:0,      sgst:0,      igst:497,   gstApplied:497,   supplierGSTIN:"07AADCV5961H2Z1", placeOfService:"09-Uttar Pradesh", status:"Invoice Received", type:"International" },
  { id:"3", invoiceNo:"VN/JD2526/0300003", invoiceDate:"04-Mar-26", customerName:"AEQUS CONSUMER PRODUCTS PVT LTD",   customerGSTIN:"29AASCA8666K1ZN", customerAddress:"Survey No 11, Hissa No 8-11, Karnataka",            passengerName:"NAVALLI/CHETAN MR",        serviceDate:"04-Mar-26", ticketNumber:"7385014305758", classBooking:"Economy",  travelDetail:"BLR\\HAN\\BLR",            baseCharge:35180,  otherCharge:1759,  totalCollection:36939,  taxRate:5,  cgst:879.5,  sgst:879.5,  igst:0,     gstApplied:1759,  supplierGSTIN:"29AADCV5961H1ZW", placeOfService:"29-Karnataka",   status:"Invoice Received", type:"International" },
  { id:"4", invoiceNo:"VN/JD2526/0300035", invoiceDate:"09-Mar-26", customerName:"FORESIGHT GLOBAL SHARED SOLUTIONS",  customerGSTIN:"27AAECF3985A1ZP", customerAddress:"ASM House, 7th Golibar Road, Santacruz East, Mumbai",passengerName:"GANDHI/RANDEEP SINGH",     serviceDate:"09-Mar-26", ticketNumber:"7385014593097", classBooking:"Business", travelDetail:"BOM\\SGN",                 baseCharge:96341,  otherCharge:17769, totalCollection:114110, taxRate:18, cgst:8671,   sgst:8671,   igst:0,     gstApplied:17342, supplierGSTIN:"27AADCV5961H1Z0", placeOfService:"27-Maharashtra", status:"Invoice Received", type:"International" },
  { id:"5", invoiceNo:"VN/JD2526/0300027", invoiceDate:"08-Mar-26", customerName:"HONEYWELL AUTOMATION INDIA LIMITED",  customerGSTIN:"27AAACT3904F1ZM", customerAddress:"53-57 Hadapsar Industrial Estate, Pune, Maharashtra", passengerName:"INGALE/RUSHIKESH HARI MR", serviceDate:"08-Mar-26", ticketNumber:"7385014508598", classBooking:"Economy",  travelDetail:"BOM\\SGN\\ICN\\SGN\\BOM",  baseCharge:39520,  otherCharge:1976,  totalCollection:41496,  taxRate:5,  cgst:988,    sgst:988,    igst:0,     gstApplied:1976,  supplierGSTIN:"27AADCV5961H1Z0", placeOfService:"27-Maharashtra", status:"Invoice Received", type:"International" },
];

function toWords(n) {
  if (!n) return "Zero Rupees and No Paises";
  const a=["","One","Two","Three","Four","Five","Six","Seven","Eight","Nine","Ten","Eleven","Twelve","Thirteen","Fourteen","Fifteen","Sixteen","Seventeen","Eighteen","Nineteen"];
  const b=["","","Twenty","Thirty","Forty","Fifty","Sixty","Seventy","Eighty","Ninety"];
  function w(x){if(!x)return"";if(x<20)return a[x]+" ";if(x<100)return b[Math.floor(x/10)]+" "+(a[x%10]?a[x%10]+" ":"");return a[Math.floor(x/100)]+" Hundred "+w(x%100);}
  const r=Math.floor(n),p=Math.round((n-r)*100);
  const g=[r%1000,Math.floor(r/1000)%100,Math.floor(r/100000)%100,Math.floor(r/10000000)];
  const s=["","Thousand","Lakh","Crore"];
  let o="";for(let i=3;i>=0;i--)if(g[i])o+=w(g[i])+s[i]+" ";
  o=o.trim()+" Rupees";o+=p>0?" and "+w(p).trim()+" Paises":" and No Paises";
  return o.replace(/\s+/g," ").trim();
}

function fmt(n){
  if(n===null||n===undefined||n===0)return" -";
  return Number(n).toLocaleString("en-IN",{minimumFractionDigits:1,maximumFractionDigits:1});
}

function InvoiceTemplate({inv}){
  const br=VNA_BRANCHES[inv.supplierGSTIN]||VNA_BRANCHES["07AADCV5961H2Z1"];
  const isIntra=inv.cgst>0||inv.sgst>0;
  const taxLabel=inv.taxRate===5?"2.5%/6.0%":"9%/18%";
  const igstLabel=inv.taxRate===5?"5.0%/12.0%":"18.0%";
  const B="1px solid #000";
  const td={border:B,padding:"3.5px 8px",fontSize:"11.5px",fontFamily:"Arial,sans-serif",verticalAlign:"middle"};
  const tdR={...td,textAlign:"right"};
  const tdC={...td,textAlign:"center"};
  return(
    <div style={{fontFamily:"Arial,sans-serif",fontSize:"11.5px",color:"#000",background:"#fff",padding:"18px 22px",width:"720px",margin:"0 auto",boxSizing:"border-box"}}>
      {/* ORIGINAL */}
      <div style={{textAlign:"right",fontStyle:"italic",fontWeight:"bold",fontSize:"11px",marginBottom:"2px"}}>ORIGINAL</div>

      <table style={{width:"100%",borderCollapse:"collapse",border:B}}>
        <tbody>
          {/* TAX INVOICE banner — grey background */}
          <tr>
            <td colSpan={3} style={{...tdC,background:"#d9d9d9",padding:"6px 8px",fontSize:"15px",fontWeight:"bold",letterSpacing:"4px",border:B}}>
              TAX INVOICE
            </td>
          </tr>

          {/* Supplier — centered block */}
          <tr>
            <td colSpan={3} style={{...tdC,padding:"8px 8px 6px",border:B}}>
              <div style={{fontWeight:"bold",fontSize:"12.5px"}}>VIETNAM AIRLINES JSC</div>
              <div>ADDRESS: {br.a1}</div>
              <div>{br.a2}</div>
              <div style={{marginBottom:"3px"}}>{br.a3}</div>
              <div style={{display:"flex",justifyContent:"center",gap:"80px"}}>
                <span>GSTIN: <strong>{inv.supplierGSTIN}</strong></span>
                <span>STATE CODE: {br.state}</span>
              </div>
              <div>PAN: AADCV5961H</div>
              <div style={{color:"#1155cc",textDecoration:"underline"}}>Website: www.vietnamairlines.com</div>
            </td>
          </tr>

          {/* Customer (left 68%) + Invoice# (right 32%) */}
          <tr style={{verticalAlign:"top"}}>
            <td colSpan={2} style={{...td,padding:"7px 8px",borderRight:B,borderBottom:B,width:"68%",verticalAlign:"top"}}>
              <table style={{borderCollapse:"collapse",width:"100%"}}>
                <tbody>
                  {[
                    ["Name:",           inv.customerName,   true ],
                    ["Address:",        inv.customerAddress,false],
                    ["GSTIN:",          inv.customerGSTIN,  false],
                    ["HSN/SAC:",        "996425 (PAX) or 996531 (CGO)",false],
                    ["Place of Service:",inv.placeOfService,false],
                    ["State Code:",     "",                 false],
                  ].map(([lbl,val,bold])=>(
                    <tr key={lbl}>
                      <td style={{fontWeight:"bold",paddingRight:"10px",paddingBottom:"2px",whiteSpace:"nowrap",width:"115px"}}>{lbl}</td>
                      <td style={{fontWeight:bold?"bold":"normal",paddingBottom:"2px"}}>{val}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </td>
            <td style={{...td,padding:"7px 8px",borderBottom:B,verticalAlign:"top",width:"32%"}}>
              <table style={{borderCollapse:"collapse",width:"100%"}}>
                <tbody>
                  <tr><td style={{paddingRight:"8px",paddingBottom:"4px",whiteSpace:"nowrap"}}>Invoice No:</td><td style={{fontWeight:"bold",paddingBottom:"4px"}}>{inv.invoiceNo}</td></tr>
                  <tr><td style={{paddingRight:"8px",paddingBottom:"4px"}}>Format:</td><td style={{paddingBottom:"4px"}}></td></tr>
                  <tr><td style={{paddingRight:"8px",whiteSpace:"nowrap"}}>Month credited:</td><td></td></tr>
                </tbody>
              </table>
            </td>
          </tr>

          {/* Column headers */}
          <tr style={{background:"#f2f2f2"}}>
            <td style={{...td,fontWeight:"bold",width:"22%",border:B}}>Particulars</td>
            <td style={{...td,fontWeight:"bold",border:B}}>Description</td>
            <td style={{...tdR,fontWeight:"bold",width:"18%",border:B}}>Amount ( INR)</td>
          </tr>

          {/* Line items */}
          {[
            ["Passenger name",inv.passengerName,null],
            ["Service date",  inv.serviceDate,  null],
            ["Ticket number", String(inv.ticketNumber),null],
            ["Class booking", inv.classBooking, null],
            ["Travel detail", inv.travelDetail, null],
            ["Base charge",   null,             inv.baseCharge],
            ["Other charge",  null,             inv.otherCharge],
          ].map(([lbl,desc,amt],i)=>(
            <tr key={i}>
              <td style={{...td,border:B}}>{lbl}</td>
              <td style={{...td,border:B}}>{desc||""}</td>
              <td style={{...tdR,border:B}}>{amt!=null?fmt(amt):""}</td>
            </tr>
          ))}

          {/* Totals */}
          <tr><td colSpan={2} style={{...tdR,border:B}}>Total collection included GST</td><td style={{...tdR,border:B}}>{fmt(inv.totalCollection)}</td></tr>
          <tr><td colSpan={2} style={{...tdR,border:B}}>GST APPLIED</td><td style={{...tdR,border:B}}>{fmt(inv.gstApplied)}</td></tr>
          <tr><td colSpan={2} style={{...tdC,fontStyle:"italic",fontSize:"10.5px",color:"#555",border:B}}>&nbsp;Detail as below:</td><td style={{...tdR,border:B}}></td></tr>
          <tr><td colSpan={2} style={{...tdR,border:B}}>{taxLabel} - SGST</td><td style={{...tdR,border:B}}>{isIntra?fmt(inv.sgst):" -"}</td></tr>
          <tr><td colSpan={2} style={{...tdR,border:B}}>{taxLabel} - CGST</td><td style={{...tdR,border:B}}>{isIntra?fmt(inv.cgst):" -"}</td></tr>
          <tr><td colSpan={2} style={{...tdR,border:B}}>{igstLabel} - IGST</td><td style={{...tdR,border:B}}>{!isIntra&&inv.igst>0?fmt(inv.igst):" -"}</td></tr>

          {/* Amount in words */}
          <tr>
            <td colSpan={3} style={{...td,border:B,padding:"5px 8px",fontSize:"11px"}}>
              <em>Amount in words: </em><strong>{toWords(inv.totalCollection)}</strong>
            </td>
          </tr>

          {/* Notes */}
          <tr>
            <td colSpan={3} style={{padding:"5px 8px",border:B,fontSize:"10.5px"}}>
              <div style={{color:"#1155cc",fontStyle:"italic"}}>This is a tax invoice for ITC purposes only and is not a payment invoice</div>
              <div style={{color:"#1155cc",fontStyle:"italic"}}>For any clarifications, please contact your ticket issuance office</div>
            </td>
          </tr>

          {/* Signatory — right-aligned, real logo */}
          <tr>
            <td colSpan={3} style={{padding:"18px 20px 22px",border:B,textAlign:"right"}}>
              <div style={{fontSize:"11.5px",marginBottom:"16px"}}>For VIETNAM AIRLINES JSC</div>
              <div style={{display:"flex",justifyContent:"flex-end",marginBottom:"14px"}}>
                <img src={vietnamLogo} alt="Vietnam Airlines" style={{height:"30px",width:"auto"}} crossOrigin="anonymous"/>
              </div>
              <div style={{fontSize:"11.5px"}}>Authorised Signatory</div>
            </td>
          </tr>

        </tbody>
      </table>
    </div>
  );
}

const API = (process.env.REACT_APP_API_URL || "http://localhost:8001") + "/api/gst";
const PAGE_SIZE = 50;

// ── Email status helpers ──────────────────────────────────────────────────────
const EMAIL_STATUSES = ["sent","opened","bounced"];

function getEmailStatus(idx) {
  const r = (idx * 2654435761) % 100;
  if (r < 10) return "bounced";
  if (r < 40) return "opened";
  return "sent";
}

const STATUS_CFG = {
  sent:    { label:"Sent",    bg:"bg-blue-50",   text:"text-blue-700",  border:"border-blue-200",  dot:"bg-blue-500",   glow:"shadow-blue-200"  },
  opened:  { label:"Opened",  bg:"bg-green-50",  text:"text-green-700", border:"border-green-200", dot:"bg-green-500",  glow:"shadow-green-200" },
  bounced: { label:"Bounced", bg:"bg-red-50",    text:"text-red-700",   border:"border-red-200",   dot:"bg-red-400",    glow:"shadow-red-200"   },
};

// Email SVG icons
const IconSent    = () => <svg className="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M22 2L11 13"/><path d="M22 2L15 22L11 13L2 9L22 2Z"/></svg>;
const IconOpened  = () => <svg className="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M21.5 12c0 .5 0 1-.1 1.5M3 8.5l9 5 9-5M3 8.5V18a1 1 0 001 1h7M3 8.5L12 3l9 5.5"/><path d="M16 19l2 2 4-4"/></svg>;
const IconBounced = () => <svg className="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>;

function EmailBadge({ idx }) {
  const s   = getEmailStatus(idx);
  const cfg = STATUS_CFG[s];
  const Icon = s === "sent" ? IconSent : s === "opened" ? IconOpened : IconBounced;
  return (
    <span className={`inline-flex items-center gap-1.5 px-2 py-1 rounded-md text-xs font-semibold border ${cfg.bg} ${cfg.text} ${cfg.border}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${cfg.dot} flex-shrink-0`}/>
      <Icon/>
      {cfg.label}
    </span>
  );
}

// ── Card → API filters ────────────────────────────────────────────────────────
const CARD_FILTERS = {
  total:{}, clean:{has_error:"false"}, errors:{has_error:"true"},
  b2b:{customer_type:"B2B"}, b2b_clean:{customer_type:"B2B",has_error:"false"}, b2b_error:{customer_type:"B2B",has_error:"true"},
  b2c:{customer_type:"B2C"}, b2c_clean:{customer_type:"B2C",has_error:"false"}, b2c_error:{customer_type:"B2C",has_error:"true"},
};
function applyFilters(p,card){const f=CARD_FILTERS[card]||{};if(f.has_error!==undefined)p.set("has_error",f.has_error);if(f.customer_type!==undefined)p.set("customer_type",f.customer_type);}

export default function ClientsPage() {
  const urlParams      = new URLSearchParams(window.location.search);
  const sessionIdParam = urlParams.get("session_id");
  const cardParam      = urlParams.get("card");

  // ── State ──────────────────────────────────────────────────────────────────
  const [rows,        setRows]       = useState([]);
  const [total,       setTotal]      = useState(0);
  const [page,        setPage]       = useState(1);
  const [loading,     setLoading]    = useState(false);
  const [restoring,   setRestoring]  = useState(!!sessionIdParam);
  const [sessionId,   setSessionId]  = useState(sessionIdParam || null);
  const [card,        setCard]       = useState(cardParam || "clean");
  const [stats,       setStats]      = useState(null);
  const [preview,     setPreview]    = useState(null);
  const [allSessions, setAllSessions]= useState([]);
  const [showDrop,    setShowDrop]   = useState(false);
  const dropRef = useRef(null);

  // ── Search & date filters ─────────────────────────────────────────────────
  const [searchInput, setSearchInput] = useState("");
  const [search,      setSearch]      = useState("");
  const [dateFrom,    setDateFrom]    = useState("");
  const [dateTo,      setDateTo]      = useState("");
  const [emailFilter, setEmailFilter] = useState("all"); // "all" | "sent" | "opened" | "bounced"

  const totalPages = Math.ceil(total / PAGE_SIZE);

  function mapRow(r) {
    const taxRate = isNaN(parseFloat(r.gst_rate)) ? 5 : Math.round(parseFloat(r.gst_rate)*100);
    return {
      id:             String(r._id||r.row_index||""),
      invoiceNo:      r.gst_invoice        ||"",
      invoiceDate:    String(r.fr_date     ||"").slice(0,10),
      customerName:   r.pax_name           ||"",
      customerGSTIN:  r.gst_id             ||"B2C",
      customerAddress:r.pos                ||"",
      passengerName:  r.pax_name           ||"",
      serviceDate:    String(r.fr_date     ||"").slice(0,10),
      ticketNumber:   r.tkt_number         ||"",
      classBooking:   r.travel_class       ||"Economy",
      travelDetail:   String(r.route       ||"").replace(/\//g,"\\"),
      baseCharge:     parseFloat(r.base_charge)      ||0,
      otherCharge:    parseFloat(r.other)            ||0,
      totalCollection:parseFloat(r.total_collection) ||0,
      taxRate,
      cgst:           parseFloat(r.cgst)             ||0,
      sgst:           parseFloat(r.sgst)             ||0,
      igst:           parseFloat(r.igst)             ||0,
      gstApplied:     parseFloat(r.gst_liability)    ||0,
      supplierGSTIN:  r.vna_gstin          ||"07AADCV5961H2Z1",
      placeOfService: r.pos                ||"07-Delhi",
      hasPdf:         !!r.pdf_s3_key,
    };
  }

  async function fetchPage(sid, activeCard, pg, srch="", from="", to="") {
    setLoading(true);
    try {
      const p = new URLSearchParams({page:pg, page_size:PAGE_SIZE});
      p.set("pdf_exists","true");
      if (sid) { p.set("session_id",sid); applyFilters(p,activeCard); }
      if (srch) p.set("search",srch);
      if (from) p.set("date_from",from);
      if (to)   p.set("date_to",to);
      const res  = await fetch(`${API}/rows?${p}`);
      if (!res.ok) throw new Error(`${res.status}`);
      const data = await res.json();
      setRows((data.items||[]).map(mapRow));
      setTotal(data.total||0);
    } catch(e){console.warn(e);}
    finally{setLoading(false);}
  }

  async function fetchStats(sid) {
    try {
      const p = new URLSearchParams();
      if (sid) p.set("session_id",sid);
      p.set("pdf_exists","true");
      const res = await fetch(`${API}/stats?${p}`);
      if (res.ok) setStats(await res.json());
    } catch {}
  }

  useEffect(()=>{
    async function init(){
      try{const sr=await fetch(`${API}/sessions?page_size=50`);if(sr.ok)setAllSessions((await sr.json()).items||[]);}catch{}
      const sid=sessionIdParam, crd=cardParam||"clean";
      if(sid){setSessionId(sid);setCard(crd);await Promise.all([fetchPage(sid,crd,1),fetchStats(sid)]);}
      else{await fetchPage(null,null,1);await fetchStats(null);}
      setRestoring(false);
    }
    init();
    const h=e=>{if(dropRef.current&&!dropRef.current.contains(e.target))setShowDrop(false);};
    document.addEventListener("mousedown",h);
    return()=>document.removeEventListener("mousedown",h);
  },[]); // eslint-disable-line

  async function switchSession(sess){
    setShowDrop(false);setSearch("");setSearchInput("");setDateFrom("");setDateTo("");
    setSessionId(sess.session_id);setCard("clean");setRows([]);setTotal(0);setPage(1);setStats(null);
    await Promise.all([fetchPage(sess.session_id,"clean",1),fetchStats(sess.session_id)]);
  }

  function handleSearch(e){
    e.preventDefault();
    setSearch(searchInput);setPage(1);
    fetchPage(sessionId,card,1,searchInput,dateFrom,dateTo);
  }
  function handleDateFilter(){
    setPage(1);
    fetchPage(sessionId,card,1,search,dateFrom,dateTo);
  }
  function clearFilters(){
    setSearch("");setSearchInput("");setDateFrom("");setDateTo("");setEmailFilter("all");setPage(1);
    fetchPage(sessionId,card,1,"","","");
  }
  function goToPage(pg){setPage(pg);fetchPage(sessionId,card,pg,search,dateFrom,dateTo);}

  async function handlePrint(inv){
    setPreview(inv);
    try{
      const res=await fetch(`${API}/invoice-pdf/${inv.id}`);
      if(!res.ok)throw new Error(`${res.status}`);
      const blob=await res.blob();const url=URL.createObjectURL(blob);
      const a=document.createElement("a");a.href=url;a.download=(inv.invoiceNo||"invoice").replace(/\//g,"_")+".pdf";
      document.body.appendChild(a);a.click();document.body.removeChild(a);URL.revokeObjectURL(url);
    }catch(e){alert("PDF failed: "+e.message);}
  }

  // Email status computed per-row (client-side, index-based)
  // Apply email filter client-side on current page
  const displayRows = emailFilter === "all"
    ? rows
    : rows.filter((_,i) => getEmailStatus((page-1)*PAGE_SIZE+i) === emailFilter);

  // Email breakdown counts for cards
  const emailCounts = { sent:0, opened:0, bounced:0, totalGST:{sent:0,opened:0,bounced:0} };
  rows.forEach((_,i)=>{
    const s = getEmailStatus((page-1)*PAGE_SIZE+i);
    emailCounts[s]++;
    emailCounts.totalGST[s] += rows[i]?.gstApplied||0;
  });
  const totalGST = rows.reduce((s,r)=>s+(r.gstApplied||0),0);

  const hasFilters = search||dateFrom||dateTo||(emailFilter!=="all");

  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-[1800px] mx-auto">

      {/* ── Header ── */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
        <div>
          <h1 className="text-2xl sm:text-3xl font-semibold text-gray-900">Clients</h1>
          <p className="text-sm text-gray-500 mt-1">
            {total>0 ? `${total.toLocaleString()} invoices` : "No invoices yet"}
            {sessionId && allSessions.find(s=>s.session_id===sessionId) ? ` · ${allSessions.find(s=>s.session_id===sessionId).filename}` : ""}
          </p>
        </div>

        {/* File selector */}
        {allSessions.length>0&&(
          <div className="relative" ref={dropRef}>
            <button onClick={()=>setShowDrop(p=>!p)}
              className="flex items-center gap-2 px-4 py-2.5 rounded-lg border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 min-w-[200px] max-w-[280px] justify-between">
              <div className="flex items-center gap-2 min-w-0">
                <FileText className="w-4 h-4 text-gray-400 flex-shrink-0"/>
                <span className="truncate">{allSessions.find(s=>s.session_id===sessionId)?.filename||"Select file"}</span>
              </div>
              <ChevronDown className="w-4 h-4 text-gray-400 flex-shrink-0"/>
            </button>
            {showDrop&&(
              <div className="absolute right-0 top-full mt-1 w-[360px] bg-white rounded-xl shadow-xl border border-gray-200 z-50 overflow-hidden">
                <div className="max-h-64 overflow-y-auto">
                  {allSessions.map(sess=>(
                    <button key={sess.session_id} onClick={()=>switchSession(sess)}
                      className={`w-full flex items-start gap-3 px-4 py-3 hover:bg-gray-50 text-left border-b border-gray-50 ${sessionId===sess.session_id?"bg-blue-50":""}`}>
                      <div className="w-8 h-8 rounded-lg bg-[#367588]/10 flex items-center justify-center mt-0.5"><FileText className="w-4 h-4 text-[#367588]"/></div>
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate">{sess.filename}</p>
                        <p className="text-xs text-gray-500 mt-0.5">{new Date(sess.uploaded_at).toLocaleString()} · {(sess.stats?.clean_rows||0).toLocaleString()} rows</p>
                      </div>
                      {sessionId===sess.session_id&&<CheckCircle className="w-4 h-4 text-blue-600 mt-1"/>}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {/* ── 4 Summary cards: Total + 3 email statuses ── */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6">
        {/* Total invoices */}
        <div className="bg-white rounded-xl border border-gray-200 p-5">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">Total Invoices</p>
          <p className="text-2xl font-bold text-gray-900">{total.toLocaleString()}</p>
          <p className="text-xs text-gray-400 mt-1">₹{totalGST.toLocaleString("en-IN",{maximumFractionDigits:0})} GST</p>
        </div>

        {/* Email status cards */}
        {(["sent","opened","bounced"]).map(s=>{
          const cfg = STATUS_CFG[s];
          const cnt = emailCounts[s];
          const gst = emailCounts.totalGST[s];
          const isActive = emailFilter===s;
          return (
            <button key={s} onClick={()=>setEmailFilter(isActive?"all":s)}
              className={`rounded-xl border-2 p-5 text-left transition-all hover:shadow-md ${
                isActive ? `${cfg.border} ring-2 ring-offset-1` : "border-gray-200 bg-white"
              } ${cfg.bg}`}>
              <div className="flex items-center justify-between mb-2">
                <p className={`text-xs font-semibold uppercase tracking-wide ${cfg.text}`}>{cfg.label}</p>
                <span className={`w-2 h-2 rounded-full ${cfg.dot} ${isActive?"ring-2 ring-offset-1 ring-current":""}`}/>
              </div>
              <p className={`text-2xl font-bold ${cfg.text}`}>{cnt.toLocaleString()}</p>
              <p className="text-xs text-gray-400 mt-1">
                ₹{gst.toLocaleString("en-IN",{maximumFractionDigits:0})} GST
                {cnt>0&&total>0 ? ` · ${Math.round(cnt/rows.length*100)}%` : ""}
              </p>
            </button>
          );
        })}
      </div>

      {/* ── Filters bar ── */}
      <div className="bg-white rounded-xl border border-gray-200 p-4 mb-4">
        <div className="flex flex-wrap items-end gap-3">

          {/* Search */}
          <form onSubmit={handleSearch} className="flex items-center gap-2 flex-1 min-w-[200px]">
            <div className="relative flex-1">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400"/>
              <input
                type="text" value={searchInput} onChange={e=>setSearchInput(e.target.value)}
                placeholder="Search passenger, ticket, invoice #…"
                className="w-full pl-9 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#367588] focus:border-transparent outline-none text-sm"
              />
            </div>
            <button type="submit" className="px-4 py-2 bg-[#367588] text-white rounded-lg text-sm font-medium hover:bg-[#2a5a6b] whitespace-nowrap">
              Search
            </button>
          </form>

          {/* Date From */}
          <div className="flex flex-col gap-1">
            <label className="text-xs font-medium text-gray-500">From Date</label>
            <input type="date" value={dateFrom} onChange={e=>{setDateFrom(e.target.value);}}
              className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-[#367588] focus:border-transparent outline-none"/>
          </div>

          {/* Date To */}
          <div className="flex flex-col gap-1">
            <label className="text-xs font-medium text-gray-500">To Date</label>
            <input type="date" value={dateTo} onChange={e=>{setDateTo(e.target.value);}}
              className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-[#367588] focus:border-transparent outline-none"/>
          </div>

          {/* Apply date filter */}
          <button onClick={handleDateFilter}
            className="px-4 py-2 border border-[#367588] text-[#367588] rounded-lg text-sm font-medium hover:bg-[#367588] hover:text-white transition-colors self-end">
            Apply
          </button>

          {/* Clear all filters */}
          {hasFilters && (
            <button onClick={clearFilters}
              className="px-4 py-2 border border-gray-300 text-gray-500 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors self-end">
              Clear All
            </button>
          )}
        </div>

        {/* Active filter chips */}
        {hasFilters && (
          <div className="flex items-center gap-2 mt-3 flex-wrap">
            <span className="text-xs text-gray-400">Active filters:</span>
            {search && <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-[#367588]/10 text-[#367588] rounded-full text-xs font-medium">Search: "{search}" <button onClick={()=>{setSearch("");setSearchInput("");fetchPage(sessionId,card,1,"",dateFrom,dateTo);}} className="ml-1 hover:text-red-500">×</button></span>}
            {dateFrom && <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-[#367588]/10 text-[#367588] rounded-full text-xs font-medium">From: {dateFrom} <button onClick={()=>{setDateFrom("");fetchPage(sessionId,card,1,search,"",dateTo);}} className="ml-1 hover:text-red-500">×</button></span>}
            {dateTo   && <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-[#367588]/10 text-[#367588] rounded-full text-xs font-medium">To: {dateTo} <button onClick={()=>{setDateTo("");fetchPage(sessionId,card,1,search,dateFrom,"");}} className="ml-1 hover:text-red-500">×</button></span>}
            {emailFilter!=="all" && <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium ${STATUS_CFG[emailFilter].bg} ${STATUS_CFG[emailFilter].text}`}>Email: {STATUS_CFG[emailFilter].label} <button onClick={()=>setEmailFilter("all")} className="ml-1 hover:opacity-60">×</button></span>}
          </div>
        )}
      </div>

      {/* ── Table ── */}
      <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
        {(loading||restoring) ? (
          <div className="flex items-center justify-center py-16 gap-3 text-gray-400">
            <div className="w-6 h-6 border-2 border-[#367588] border-t-transparent rounded-full animate-spin"/>
            <span className="text-sm">Loading invoices…</span>
          </div>
        ):(
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  {["Invoice #","Date","Passenger / Ticket","Customer / GSTIN","Route","Class","Base (₹)","GST (₹)","Total (₹)","Status","Recipient Email","Email Status","Actions"].map(h=>(
                    <th key={h} className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {displayRows.length===0 ? (
                  <tr><td colSpan={13} className="px-6 py-12 text-center text-gray-400 text-sm">
                    {total===0 ? "No invoices — go to Validate Data to generate them" : "No results for current filters"}
                  </td></tr>
                ):displayRows.map((inv,ri)=>{
                  const globalIdx = (page-1)*PAGE_SIZE + rows.indexOf(inv);
                  return (
                    <tr key={inv.id} className="hover:bg-gray-50 transition-colors">
                      <td className="px-4 py-3 font-mono text-xs font-medium text-blue-700 whitespace-nowrap">{inv.invoiceNo||"—"}</td>
                      <td className="px-4 py-3 text-sm text-gray-700 whitespace-nowrap">{inv.invoiceDate}</td>
                      <td className="px-4 py-3 text-sm max-w-[160px]">
                        <div className="font-medium text-gray-900 truncate">{inv.passengerName}</div>
                        <div className="text-xs text-gray-500 font-mono">{inv.ticketNumber}</div>
                      </td>
                      <td className="px-4 py-3 text-sm max-w-[180px]">
                        <div className="font-medium text-gray-900 truncate">{inv.customerName}</div>
                        <div className="text-xs font-mono text-gray-500">{inv.customerGSTIN}</div>
                      </td>
                      <td className="px-4 py-3 text-xs font-mono text-gray-700 max-w-[100px]"><div className="truncate">{inv.travelDetail}</div></td>
                      <td className="px-4 py-3 text-sm text-gray-700 whitespace-nowrap">{inv.classBooking}</td>
                      <td className="px-4 py-3 text-sm text-right text-gray-900 whitespace-nowrap">{(inv.baseCharge||0).toLocaleString("en-IN")}</td>
                      <td className="px-4 py-3 text-right whitespace-nowrap">
                        <span className="text-sm font-semibold text-[#367588]">{(inv.gstApplied||0).toLocaleString("en-IN")}</span>
                        <div className="text-xs text-gray-400">{inv.taxRate}%</div>
                      </td>
                      <td className="px-4 py-3 text-sm text-right font-bold text-gray-900 whitespace-nowrap">{(inv.totalCollection||0).toLocaleString("en-IN")}</td>
                      <td className="px-4 py-3">
                        <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${inv.hasPdf?"bg-green-100 text-green-800":"bg-yellow-100 text-yellow-800"}`}>
                          {inv.hasPdf?"PDF Ready":"Pending"}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-xs font-mono text-gray-500 whitespace-nowrap">dummy@companydomain.com</td>
                      <td className="px-4 py-3 whitespace-nowrap"><EmailBadge idx={globalIdx}/></td>
                      <td className="px-4 py-3">
                        <div className="flex items-center gap-1.5">
                          <button onClick={()=>setPreview(inv)} className="flex items-center gap-1 px-2.5 py-1.5 bg-[#367588]/10 text-[#367588] rounded-lg hover:bg-[#367588]/20 text-xs font-medium">
                            <Eye className="w-3.5 h-3.5"/>View
                          </button>
                          <button onClick={()=>handlePrint(inv)} className={`flex items-center gap-1 px-2.5 py-1.5 rounded-lg text-xs font-medium text-white ${inv.hasPdf?"bg-green-600 hover:bg-green-700":"bg-[#367588] hover:bg-[#2a5a6b]"}`}>
                            <Printer className="w-3.5 h-3.5"/>{inv.hasPdf?"PDF ✓":"PDF"}
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        {/* Footer */}
        <div className="px-6 py-3 border-t border-gray-200 bg-gray-50 flex items-center justify-between flex-wrap gap-3">
          <span className="text-xs text-gray-500">
            Showing {displayRows.length>0?(page-1)*PAGE_SIZE+1:0}–{Math.min(page*PAGE_SIZE,total)} of {total.toLocaleString()}
            {emailFilter!=="all" ? ` · ${displayRows.length} matching ${STATUS_CFG[emailFilter].label}` : ""}
          </span>
          {totalPages>1&&(
            <div className="flex items-center gap-2">
              <button onClick={()=>goToPage(1)} disabled={page<=1||loading} className="px-2 py-1 text-xs border rounded disabled:opacity-30 hover:bg-white">«</button>
              <button onClick={()=>goToPage(page-1)} disabled={page<=1||loading} className="px-3 py-1 text-xs border rounded disabled:opacity-30 hover:bg-white">‹ Prev</button>
              <span className="text-xs text-gray-600 font-medium px-2">Page {page} / {totalPages}</span>
              <button onClick={()=>goToPage(page+1)} disabled={page>=totalPages||loading} className="px-3 py-1 text-xs border rounded disabled:opacity-30 hover:bg-white">Next ›</button>
              <button onClick={()=>goToPage(totalPages)} disabled={page>=totalPages||loading} className="px-2 py-1 text-xs border rounded disabled:opacity-30 hover:bg-white">»</button>
            </div>
          )}
          <span className="text-xs text-gray-500">
            Total GST: ₹{displayRows.reduce((s,r)=>s+(r.gstApplied||0),0).toLocaleString("en-IN")}
          </span>
        </div>
      </div>

      {/* Preview modal */}
      {preview&&(
        <div className="fixed inset-0 bg-black/60 flex items-start justify-center p-4 z-50 overflow-y-auto" onClick={()=>setPreview(null)}>
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-3xl my-6" onClick={e=>e.stopPropagation()}>
            <div className="flex items-center justify-between p-4 border-b border-gray-200 sticky top-0 bg-white rounded-t-xl z-10">
              <div>
                <p className="font-semibold text-gray-900">{preview.invoiceNo}</p>
                <p className="text-xs text-gray-500">{preview.passengerName} · {preview.invoiceDate}</p>
              </div>
              <div className="flex items-center gap-2">
                <button onClick={()=>handlePrint(preview)} className="flex items-center gap-2 px-4 py-2 bg-[#367588] text-white rounded-lg hover:bg-[#2a5a6b] text-sm font-medium">
                  <Printer className="w-4 h-4"/>Download PDF
                </button>
                <button onClick={()=>setPreview(null)} className="p-2 hover:bg-gray-100 rounded-lg"><X className="w-5 h-5 text-gray-400"/></button>
              </div>
            </div>
            <div className="p-6 bg-gray-100 overflow-auto">
              <div id="inv-print-area"><InvoiceTemplate inv={preview}/></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}